import { z } from "zod";

export const personalInfoScheme = z.object({
  name: z.string().min(3),
  phone: z.string().min(16).max(16),
  email: z.string().min(0).nullish(),
  comment: z.string().min(0),
  reminder: z.number(),
  bookingPrepaymentValue: z.string(),
  defaultEquipment: z.string(),
  termsAccepted: z.boolean().refine((val) => val, {
    message: "Прийміть правила вище, щоб продовжити",
  }),
});

export type PersonalInfoFormScheme = z.infer<typeof personalInfoScheme>;
